import React from 'react'
import { Helmet } from 'react-helmet'
import Header from '../../../Components/Header'
import MainList  from "./MainList"

const QualityActionList = () => {
  return (
    <div>
      <Helmet>
        <title>Quality Action List</title>
      </Helmet>

      <Header />

      <MainList />

    </div>
  )
}

export default QualityActionList